/**
 * Las novedades del trabajador, de un vistazo, en la cabecera de su ficha:
 * de vacaciones, con licencia o permiso, contrato por vencer, solicitudes
 * esperando aprobación, documentos sin firmar.
 *
 * ⚠️ Acá no se calcula nada: las alertas vienen del backend
 * (payroll/alertas_empleado.py), que usa los MISMOS criterios de las pestañas
 * de detalle — si este panel decidiera por su cuenta, podría afirmar una
 * novedad que la pestaña de Vacaciones después desmiente.
 */
import { AlertTriangle, Info } from 'lucide-react'
import type { AlertaDelEmpleado } from '../hooks/usePayroll'

const ESTILO: Record<AlertaDelEmpleado['nivel'], string> = {
  danger: 'bg-danger-surface border-danger-border text-danger-content',
  warning: 'bg-warning-surface border-warning-border text-warning-content',
  info: 'bg-info-surface border-info-border text-info-content',
}

export function AlertasDelEmpleado({ alertas }: { alertas?: AlertaDelEmpleado[] }) {
  if (!alertas || alertas.length === 0) {
    return (
      <p className="text-xs text-content-muted">Sin novedades vigentes.</p>
    )
  }
  return (
    <ul aria-label="Novedades del trabajador" className="flex flex-col gap-1.5">
      {alertas.map(a => {
        const Icono = a.nivel === 'info' ? Info : AlertTriangle
        return (
          <li
            key={`${a.codigo}-${a.mensaje}`}
            className={`flex items-start gap-1.5 rounded-lg border px-2.5 py-1.5 text-xs font-medium ${ESTILO[a.nivel]}`}
          >
            <Icono size={13} className="mt-px flex-shrink-0" aria-hidden="true" />
            <span>{a.mensaje}</span>
          </li>
        )
      })}
    </ul>
  )
}
